import { render, staticRenderFns } from "./KusDocumentUploadBtn.vue?vue&type=template&id=fc6dde3c"
import script from "./KusDocumentUploadBtn.vue?vue&type=script&lang=js"
export * from "./KusDocumentUploadBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports